import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('selectlistbox');

export { TAG_NAME };
